<div class="qr-dialog">
  <div class="qr-dialog-title-row">
    <div class="qr-dialog-left">{{ 'Book_betting' | translate }}</div>
    <div class="qr-dialog-right">
      <div class="close" (click)="onNoClick()">X</div>
    </div>
  </div>
  <div class="qr-dialog-content">
    <qrcode [qrdata]="data.barcode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
  </div>
  <div *ngIf="this._DataService.isMobileView" class="qr-code-reversed">
    <div class="qr-code-reversed-container" [ngClass]="this.isReserveButton ? '' : 'disabled'" (click)="this.betReserveHandler()">
      <image-loader-utils url="share"></image-loader-utils>
      <div class="qr-code-reversed-container-text">{{ 'RESERVE_BETS' | translate }}</div>
    </div>
  </div>
  <div *ngIf="this.isReservePageLink" class="reverse-route-link" (click)="reverseRouteHandler()">
    {{ 'BOOK_BET_RESERVE_ROUTE_TEXT' | translate }}
  </div>
  <div class="qr-dialog-number" (click)="copyClickBoard(data.barcode)">
    <span>
      <div class="mr-10">
        {{ 'Enter_booking_code' | translate }}
      </div>
      <div class="fw-8">
        {{ this.textReplaceF(data.barcode) }}
      </div>
    </span>
    <image-loader-utils url="copy" extraClasses="copy-icon"></image-loader-utils>
  </div>
</div>
<div class="share-social-media">
  <div *ngFor="let platform of socialPlatforms" class="social-icon-wrapper">
    <image-loader-utils (click)="shareOnSocialMedia(platform)" [imageFormat]="'png'" [url]="platform.icon" extraClasses="social-icon-item"></image-loader-utils>
  </div>
</div>
